import React, { Component } from "react";
import { Container, Form, Button, Card, Spinner } from "react-bootstrap";
import './Images.css';

import { Configuration, OpenAIApi } from 'openai'; 

const configuration = new Configuration({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY
});
const openai = new OpenAIApi(configuration);

class Images extends Component {
    constructor() {
        super();
        this.state = {
            heading: "The image will appear here",
            response: "...creating image...",
            size: "large",
            generatedText: "Poem will appear here",
            isLoadingText: false,
            isLoadingImage: false
        };
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        this.setState({ isLoadingText: true });

       
      

        openai.createCompletion({
           
                model: "text-davinci-003",
                prompt: 
                `Create a poem in the style of the Jabberwocky poem of Lewis carrol,same strategy and length,  Its playful, whimsical language has given English nonsense words and neologisms such as "galumphing" and "chortle" `,
              
                
                temperature: 0.9,
                max_tokens: 200,
                top_p: 1,
                frequency_penalty: 0,
                presence_penalty: 0,
               
            }).then((response) => {
                this.setState({
                    generatedText: `${response.data.choices[0].text}`,
                    isLoadingText: false,
                }, () => {
                    this.setState({ isLoadingImage: true });
                    openai.createImage({
                    prompt: `pencil and charcoal drawaing, style of William Blake${response.data.choices[0].text}`,
                    n: 1,
                    size: this.state.size === "large" ? "1024x1024" : this.state.size === "medium" ? "512x512" : "256x256",
                }).then((response) => {
                    this.setState({
                      
                        response: `${response.data.data[0].url}`,
                        isLoadingImage: false
                    });
                }).catch((error) => {
                    console.log(error);
                });
            });
        }).catch((error) => {
            console.log(error);
        });
    }

    handleSizeChange = (e) => {
        this.setState({ size: e.target.value });
    }

    render() {
        return (
            <div className="images">
                 
                <Container className="images-container">
                <h2>Endless Jabberwocky</h2>
                   
                    <p className="subtitle-text"> A poem in the style of Jabberwocky and a  new image inspired in the text are generated using AI.
                    <b>"Jabberwocky" </b> 
                  <a target="_blank" rel="noreferrer" href="https://www.poetryfoundation.org/poems/42916/jabberwocky"> by Lewis Carroll</a> is a nonsense poem about the killing of a creature named "the Jabberwock". It was included in his 1871 novel Through the Looking-Glass, the sequel to Alice's Adventures in Wonderland (1865). The book tells of Alice's adventures within the back-to-front world of Looking-glass world. "Jabberwocky" is considered one of the greatest nonsense poems written in English. Its playful, whimsical language has given English nonsense words and neologisms such as "galumphing" and "chortle".
                    </p>
                    <Form onSubmit={this.onFormSubmit} className="form-inline">
    <Form.Group controlId="formSize" className="form-group">
       
    </Form.Group>
    <Button className="vintage-button" type="submit">Generate</Button>

</Form>

                    <Card className="images-card rounded-card">
                        <Card.Body>
                            <Card.Text className="images-text">
                                {this.state.isLoadingText ? (
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only"><div class="lds-hourglass"></div></span>
                                    </Spinner>
                                ) : (
                                    <p className="generated-text">{this.state.generatedText}</p>
                                )}
                                {this.state.isLoadingImage ? (
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only"><div class="lds-hourglass"></div></span>
                                    </Spinner>
                                ) : (
                                    <div className="image-wrapper">
                                        <a 
                                            className="image-link"
                                            download="artifact"
                                            rel="noreferrer"
                                            href={this.state.response}
                                            target="_blank">
                                          <img 
    className={`generated-image ${this.state.isLoadingImage ? '' : 'loaded'}`} 
    src={this.state.response} 
    alt=''/>
                                        </a>
                                    </div>
                                )}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        );
    }
}

export default Images;